import { render, staticRenderFns } from "./MaskC.vue?vue&type=template&id=1e81d6ef&scoped=true&"
import script from "./MaskC.vue?vue&type=script&lang=js&"
export * from "./MaskC.vue?vue&type=script&lang=js&"
import style0 from "./MaskC.vue?vue&type=style&index=0&id=1e81d6ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e81d6ef",
  null
  
)

component.options.__file = "MaskC.vue"
export default component.exports